/* CRO Optimization */
document.addEventListener('DOMContentLoaded', () => {
  // Preserve the homepage position when Shopify's theme preview hot-reloads
  // after an online-theme update. Normal visits and link navigation still
  // start at the top as usual.
  if (document.body.classList.contains('template-index')) {
    const scrollStorageKey = `cro-home-scroll:${window.location.pathname}`;
    const navigationEntry = window.performance?.getEntriesByType?.('navigation')?.[0];
    const isReload = navigationEntry?.type === 'reload' || window.performance?.navigation?.type === 1;
    let saveTimer;

    const saveHomepageScroll = () => {
      try {
        window.sessionStorage.setItem(scrollStorageKey, String(window.scrollY));
      } catch (_error) {
        // Storage can be unavailable in privacy-restricted browsers.
      }
    };

    window.addEventListener('scroll', () => {
      window.clearTimeout(saveTimer);
      saveTimer = window.setTimeout(saveHomepageScroll, 100);
    }, { passive: true });
    window.addEventListener('pagehide', saveHomepageScroll);

    if (isReload) {
      let savedScrollY = 0;
      try {
        savedScrollY = Number(window.sessionStorage.getItem(scrollStorageKey) || 0);
      } catch (_error) {
        // Keep the browser's native restoration behavior as the fallback.
      }

      if (savedScrollY > 0) {
        const restoreHomepageScroll = () => window.scrollTo(0, savedScrollY);
        window.requestAnimationFrame(() => window.requestAnimationFrame(restoreHomepageScroll));
        window.addEventListener('load', restoreHomepageScroll, { once: true });
      }
    }
  }

  // CRO Optimization: keep the Growave Rewards launcher in the header.
  const getRewardsLauncher = () => document
    .querySelector('.gw-rd-popup-widget-placeholder')
    ?.shadowRoot?.querySelector('button[aria-label="Open Rewards popup"]');

  const syncRewardsLauncherStyle = () => {
    const rewardsRoot = document.querySelector('.gw-rd-popup-widget-placeholder')?.shadowRoot;
    if (rewardsRoot && !rewardsRoot.getElementById('CRO-Rewards-Launcher-Style')) {
      const rewardsStyle = document.createElement('style');
      rewardsStyle.id = 'CRO-Rewards-Launcher-Style';
      rewardsStyle.textContent = '.gw-rd-popup-widget-launcher{display:none!important}';
      rewardsRoot.appendChild(rewardsStyle);
    }
    return Boolean(rewardsRoot);
  };

  const openRewardsLauncher = (attempt = 0) => {
    const rewardsLauncher = getRewardsLauncher();
    if (rewardsLauncher) {
      rewardsLauncher.click();
      window.setTimeout(syncRewardsLauncherStyle, 0);
      window.setTimeout(syncRewardsLauncherStyle, 250);
      window.setTimeout(syncRewardsLauncherStyle, 1000);
      return;
    }

    if (attempt < 20) {
      window.setTimeout(() => openRewardsLauncher(attempt + 1), 150);
    }
  };

  document
    .querySelector('[data-cro-app-launcher="rewards"]')
    ?.addEventListener('click', () => openRewardsLauncher());

  let appLauncherAttempts = 0;
  const appLauncherTimer = window.setInterval(() => {
    appLauncherAttempts += 1;
    if (syncRewardsLauncherStyle() || appLauncherAttempts >= 80) {
      window.clearInterval(appLauncherTimer);
    }
  }, 250);

  // CRO Optimization: style Growave's product-card wishlist button inside Shadow DOM.
  const cardWishlistStyles = `
    :host > div {
      width: 100% !important;
      height: 100% !important;
    }
    button {
      width: 100% !important;
      height: 100% !important;
      min-width: 100% !important;
      min-height: 100% !important;
      padding: 0 !important;
      border: 0 !important;
      border-radius: 9999px !important;
      background: rgba(255, 255, 255, 0.4) !important;
      box-shadow: none !important;
      color: #111827 !important;
    }
    button svg {
      width: 22px !important;
      height: 22px !important;
      color: #111827 !important;
    }
    button[data-in-wishlist="true"],
    button[data-in-wishlist="true"] svg {
      color: #ef323f !important;
    }
    button:not([data-in-wishlist="true"]) svg path,
    button[data-in-wishlist="false"] svg path {
      fill: none !important;
      stroke: #111827 !important;
    }
    button[data-in-wishlist="true"] svg path {
      fill: #ef323f !important;
      stroke: #ef323f !important;
    }
    .gw-toggle-wishlist-product-card-button__counter,
    button > div,
    button [class*="counter" i],
    button [class*="count" i] {
      display: none !important;
    }
    button:focus-visible {
      outline: 2px solid #111827 !important;
      outline-offset: 2px !important;
    }
  `;

  const styleCardWishlistButtons = () => {
    document.querySelectorAll('[data-cro-card-wishlist]').forEach((host) => {
      const shadowRoot = host.shadowRoot;
      if (!shadowRoot) return;

      let style = shadowRoot.getElementById('CRO-Card-Wishlist-Style');
      if (!style) {
        style = document.createElement('style');
        style.id = 'CRO-Card-Wishlist-Style';
        shadowRoot.appendChild(style);
      }
      if (style.textContent !== cardWishlistStyles) style.textContent = cardWishlistStyles;
    });
  };

  styleCardWishlistButtons();
  let cardWishlistStyleAttempts = 0;
  const cardWishlistStyleTimer = window.setInterval(() => {
    cardWishlistStyleAttempts += 1;
    styleCardWishlistButtons();
    if (cardWishlistStyleAttempts >= 80) {
      window.clearInterval(cardWishlistStyleTimer);
    }
  }, 250);

  const cardWishlistObserver = new MutationObserver(styleCardWishlistButtons);
  cardWishlistObserver.observe(document.documentElement, { childList: true, subtree: true });
  window.setInterval(styleCardWishlistButtons, 3000);

  // CRO Optimization: Growave's drawer open rule loses to its position rule inside Shadow DOM.
  let growaveDrawerFixAttempts = 0;
  const growaveDrawerFixTimer = window.setInterval(() => {
    growaveDrawerFixAttempts += 1;
    const host = document.querySelector('.gw-reviews-drawer-widget-placeholder');
    const shadowRoot = host?.shadowRoot;
    if (shadowRoot && !shadowRoot.getElementById('CRO-Growave-Reviews-Fix')) {
      const style = document.createElement('style');
      style.id = 'CRO-Growave-Reviews-Fix';
      style.textContent = '.gw-drawer.gw-drawer--open .gw-drawer__sidebar{transform:translateX(0) translateZ(0)!important}';
      shadowRoot.appendChild(style);
    }
    const drawer = shadowRoot?.querySelector('.gw-drawer');
    const sidebar = shadowRoot?.querySelector('.gw-drawer__sidebar');
    const applyReviewsScrollFix = () => {
      const reviewsContentRoot = shadowRoot?.querySelector('.gw-rv-widget-container')?.shadowRoot;
      if (reviewsContentRoot && !reviewsContentRoot.getElementById('CRO-Growave-Reviews-Scroll-Fix')) {
        const scrollStyle = document.createElement('style');
        scrollStyle.id = 'CRO-Growave-Reviews-Scroll-Fix';
        scrollStyle.textContent = '.gw-scrollable{overscroll-behavior-y:contain!important;-webkit-overflow-scrolling:touch;padding-bottom:calc(5rem + env(safe-area-inset-bottom))!important;scroll-padding-bottom:calc(5rem + env(safe-area-inset-bottom))!important}.gw-rv-widget__brand{display:none!important}';
        reviewsContentRoot.appendChild(scrollStyle);
      }
      return reviewsContentRoot;
    };
    const reviewsContentRoot = applyReviewsScrollFix();
    if (shadowRoot && !host.hasAttribute('data-cro-scroll-observed')) {
      host.setAttribute('data-cro-scroll-observed', '');
      new MutationObserver(applyReviewsScrollFix).observe(shadowRoot, { childList: true, subtree: true });
    }
    if (drawer && sidebar && !drawer.hasAttribute('data-cro-drawer-observed')) {
      drawer.setAttribute('data-cro-drawer-observed', '');
      const syncDrawerPosition = () => {
        const isOpen = drawer.classList.contains('gw-drawer--open');

        if (isOpen) {
          sidebar.style.setProperty('transform', 'translateX(0) translateZ(0)', 'important');
          if (!document.body.classList.contains('cro-reviews-drawer-open')) {
            document.body.dataset.croReviewsScrollY = String(window.scrollY);
            document.body.style.setProperty('position', 'fixed', 'important');
            document.body.style.setProperty('top', `-${window.scrollY}px`, 'important');
            document.body.style.setProperty('width', '100%', 'important');
          }
          document.documentElement.classList.add('cro-reviews-drawer-open');
          document.body.classList.add('cro-reviews-drawer-open');
          applyReviewsScrollFix();
          window.setTimeout(applyReviewsScrollFix, 250);
          window.setTimeout(applyReviewsScrollFix, 1000);
        } else {
          sidebar.style.setProperty('transform', 'translateX(-100%) translateZ(0)', 'important');
          const hasSavedScroll = document.body.dataset.croReviewsScrollY !== undefined;

          // Growave initializes the drawer in its closed state. Do not scroll
          // during that initial sync; only restore after a real open/close cycle.
          if (hasSavedScroll) {
            const savedScrollY = Number(document.body.dataset.croReviewsScrollY);
            document.documentElement.classList.remove('cro-reviews-drawer-open');
            document.body.classList.remove('cro-reviews-drawer-open');
            document.body.style.removeProperty('position');
            document.body.style.removeProperty('top');
            document.body.style.removeProperty('width');
            delete document.body.dataset.croReviewsScrollY;
            window.scrollTo(0, savedScrollY);
          }
        }
      };
      new MutationObserver(syncDrawerPosition).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      syncDrawerPosition();
    }
    if ((drawer && sidebar && reviewsContentRoot) || growaveDrawerFixAttempts >= 30) {
      window.clearInterval(growaveDrawerFixTimer);
    }
  }, 500);

  const sticky = document.querySelector('[data-cro-sticky-atc]');
  const primaryButton = document.querySelector('.product-buy-button button[type="submit"]:not([disabled])');
  if (sticky && primaryButton) {
    const stickyButton = sticky.querySelector('[data-cro-sticky-button]');
    stickyButton?.addEventListener('click', () => primaryButton.click());
    const observer = new IntersectionObserver(([entry]) => {
      sticky.hidden = entry.isIntersecting;
    }, { threshold: 0.05 });
    observer.observe(primaryButton);

    document.addEventListener('variant:change', (event) => {
      const variant = event.detail?.variant;
      if (!variant) return;
      stickyButton.disabled = !variant.available;
      stickyButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
    });
  }

  document.querySelectorAll('.collection-description').forEach((description) => {
    if (description.scrollHeight <= 160 || description.querySelector('[data-cro-read-more]')) return;
    description.classList.add('cro-description-collapsed');
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'button button--small button--tertiary';
    button.dataset.croReadMore = '';
    button.textContent = 'Read more';
    button.addEventListener('click', () => {
      const collapsed = description.classList.toggle('cro-description-collapsed');
      button.textContent = collapsed ? 'Read more' : 'Show less';
    });
    description.after(button);
  });

  // CRO Optimization: one-tap product-card add, silent cart update, fly-to-cart feedback.
  const handleDirectCardAdd = async (event) => {
    const button = event.currentTarget;
    if (!button || button.disabled || button.classList.contains('loading')) return;

    event.preventDefault();
    event.stopPropagation();
    button.dataset.croAddState = 'loading';

    const cartTarget = document.getElementById('Cart-Icon-Bubble');
    const card = button.closest('.product-card-wrapper');
    const productImage = card?.querySelector('.product-card-featured-image img, img.product-card-featured-image, .card-media img');
    const sourceRect = productImage?.getBoundingClientRect();
    const targetRect = cartTarget?.getBoundingClientRect();
    const drawer = document.getElementById('Cart-Drawer');
    const sections = [
      { id: 'Cart-Icon-Bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    ];

    if (drawer?.dataset.section) {
      sections.push({ id: 'Cart-Drawer', section: drawer.dataset.section, selector: '#Cart-Drawer-Details' });
    }

    button.classList.add('loading');
    button.disabled = true;

    try {
      const formData = new FormData();
      formData.append('id', button.dataset.variantId);
      formData.append('quantity', '1');
      formData.append('sections', sections.map((section) => section.section).join());
      formData.append('sections_url', window.location.pathname);

      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item.');
      button.dataset.croAddState = 'success';

      // CRO Optimization: finish the 4×4px fly-to-bag animation before changing the count/toast.
      if (productImage && sourceRect && targetRect && sourceRect.width && sourceRect.height) {
        const flyer = productImage.cloneNode(true);
        flyer.className = 'cro-cart-flyer';
        flyer.setAttribute('aria-hidden', 'true');
        Object.assign(flyer.style, {
          left: `${sourceRect.left}px`,
          top: `${sourceRect.top}px`,
          width: `${sourceRect.width}px`,
          height: `${sourceRect.height}px`,
        });
        document.body.appendChild(flyer);
        const translateX = targetRect.left + targetRect.width / 2 - (sourceRect.left + sourceRect.width / 2);
        const translateY = targetRect.top + targetRect.height / 2 - (sourceRect.top + sourceRect.height / 2);
        const scaleX = 4 / sourceRect.width;
        const scaleY = 4 / sourceRect.height;
        const animation = flyer.animate([
          { transform: 'translate3d(0,0,0) scale3d(1,1,1)', opacity: 0.95 },
          {
            transform: `translate3d(${translateX}px,${translateY}px,0) scale3d(${scaleX},${scaleY},1)`,
            opacity: 0.35,
          },
        ], { duration: 1300, easing: 'cubic-bezier(.2,.72,.2,1)' });
        await Promise.race([
          animation.finished.catch(() => undefined),
          new Promise((resolve) => window.setTimeout(resolve, 1700)),
        ]);
        flyer.remove();
      }

      if (typeof SectionDynamicUpdate !== 'undefined' && result.sections) {
        SectionDynamicUpdate.updateSections(sections, result.sections);
      }

      const refreshedCartTarget = document.getElementById('Cart-Icon-Bubble');
      refreshedCartTarget?.classList.add('cro-cart-bump');
      window.setTimeout(() => refreshedCartTarget?.classList.remove('cro-cart-bump'), 550);
      showCroCartToast(button.dataset.successMessage || 'Added to cart', false);
    } catch (error) {
      button.dataset.croAddState = 'error';
      button.dataset.croAddError = error.message || 'Unknown error';
      showCroCartToast(error.message || 'Unable to add this item.', true);
    } finally {
      button.classList.remove('loading');
      button.disabled = false;
    }
  };

  const bindDirectCardAdds = (root = document) => {
    root.querySelectorAll?.('[data-cro-direct-add]:not([data-cro-direct-add-bound])').forEach((button) => {
      button.dataset.croDirectAddBound = '';
      button.addEventListener('click', handleDirectCardAdd);
    });
  };
  bindDirectCardAdds();
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) bindDirectCardAdds(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });
});

function showCroCartToast(message, isError) {
  document.querySelector('[data-cro-cart-toast]')?.remove();
  const toast = document.createElement('div');
  toast.className = `cro-cart-toast${isError ? ' cro-cart-toast--error' : ''}`;
  toast.dataset.croCartToast = '';
  toast.setAttribute('role', isError ? 'alert' : 'status');
  toast.textContent = message;
  document.body.appendChild(toast);
  requestAnimationFrame(() => toast.classList.add('is-visible'));
  window.setTimeout(() => {
    toast.classList.remove('is-visible');
    window.setTimeout(() => toast.remove(), 250);
  }, 7000);
}
